import { BaseModel } from './base.model'
import * as _ from 'lodash'
import { Constants } from 'config'

export class HubTimeInterval extends BaseModel<HubTimeInterval> {
  static DEFAULT_ATTRIBUTES = {
    slotNumber: 18,
    hoursFrom: 8,
    hoursTo: 17,
    minutesFrom: 0,
    minutesTo: 0
  }

  id: number
  slotNumber: number
  hoursFrom: number
  hoursTo: number
  minutesFrom: number
  minutesTo: number
  _destroy: boolean

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/hub-time-interval.model.ts